// extracted by mini-css-extract-plugin
module.exports = {"benefit-icon":"BenefitCard_benefit-icon__3qp73","benefit-title":"BenefitCard_benefit-title__3Hy83","benefit-content":"BenefitCard_benefit-content__2tOD4"};